import { render } from "./DemoLeadsView.vue?vue&type=template&id=3c7fc491&scoped=true"
import script from "./DemoLeadsView.vue?vue&type=script&lang=js"
export * from "./DemoLeadsView.vue?vue&type=script&lang=js"

import "./DemoLeadsView.vue?vue&type=style&index=0&id=3c7fc491&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7fc491"]])

export default __exports__